import { useState } from "react";
import { Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import logo from "../assets/phelifla-logo.png";
import { Alert, Button, Loader } from "../components/ui";
import { useAuth } from "../contexts/AuthContext";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

const POPUP_FECHADO = ["auth/popup-closed-by-user", "auth/cancelled-popup-request"];

export default function Login() {
  const { status, email, login } = useAuth();
  const [entrando, setEntrando] = useState(false);
  const [erro, setErro] = useState("");

  if (status === "admin") return <Navigate to="/" replace />;
  if (status === "loading" && !entrando) return <Loader page />;

  const entrar = async () => {
    setErro("");
    setEntrando(true);
    try {
      await login();
    } catch (e) {
      if (!POPUP_FECHADO.includes(e.code)) setErro("Não foi possível entrar com o Google. Tente novamente.");
    } finally {
      setEntrando(false);
    }
  };

  return (
    <div className="auth">
      <div className="card auth__card card--accent">
        <img src={logo} alt="PheliFla" className="auth__logo" />
        <h1>
          Pheli<span>Fla</span> Admin
        </h1>
        <p className="muted" style={{ margin: "6px 0 24px" }}>
          Painel de gerenciamento do app.
        </p>

        <div className="stack">
          {status === "denied" && (
            <Alert tone="error">
              <strong>{email}</strong> não tem acesso de administrador.
            </Alert>
          )}
          {erro && <Alert tone="error">{erro}</Alert>}

          <Button className="btn--google" block onClick={entrar} loading={entrando}>
            {!entrando && <GoogleIcon />}
            Entrar com Google
          </Button>

          <p className="small muted row" style={{ justifyContent: "center" }}>
            <ShieldCheck size={14} /> Acesso restrito a administradores.
          </p>
        </div>
      </div>
    </div>
  );
}
